import React, { useState } from 'react';
import JourneyBarFirstStep from './JourneyBarFirstStep';
import JourneyBarNextStep from './JourneyBarNextStep';
import JourneyBarLastStep from './JourneyBarLastStep';
import {
    stepStyle,
    currentStepLabelStyle,
    onwardStepLabelStyle,
    currentStepStyle,
    editedStepStyle,
    disabledStepStyle,
    uneditedStepStyle
} from './JourneyBarStyles';

const JourneyBarStep = ({
    step,
    index,
    currentStep,
    onClick,
    width,

    currStep // ToDo: Rename this to currentStep after removing useState currentStep
}) => {
    // State
    const [isHovering, setIsHovering] = useState(false);

    const updateHovering = (step, hovering) => {
        if (step.enabled) {
            setIsHovering(hovering);
        }
    };

    const StepType = (index, step, isHovering) => {
        let sStyle;
        if (step.isFirst) {
            if (currentStep > index) {
                sStyle = editedStepStyle;
            } else {
                if (step.currentStep) {
                    sStyle = currentStepStyle;
                } else {
                    sStyle = editedStepStyle;
                }
            }
            return (
                <JourneyBarFirstStep
                    name={step.name}
                    width={width}
                    style={{
                        ...sStyle,
                        fill: isHovering ? '#FAA800' : sStyle.fill
                    }}
                />
            );
        } else if (step.isLast) {
            if (step.currentStep) {
                sStyle = currentStepStyle;
            } else if (step.enabled) {
                if (step.stepEdited) {
                    sStyle = editedStepStyle;
                } else {
                    sStyle = uneditedStepStyle;
                }
            } else {
                sStyle = disabledStepStyle;
            }
            return (
                <JourneyBarLastStep
                    name={step.name}
                    width={width}
                    style={{
                        ...sStyle,
                        fill: isHovering ? '#FAA800' : sStyle.fill
                    }}
                />
            );
        } else {
            if (index > currentStep) {
                if (step.enabled) {
                    if (step.stepEdited) {
                        sStyle = editedStepStyle;
                    } else {
                        sStyle = uneditedStepStyle;
                    }
                } else {
                    sStyle = disabledStepStyle;
                }
            } else if (index === currentStep) {
                sStyle = currentStepStyle;
            } else {
                if (step.stepEdited) {
                    sStyle = editedStepStyle;
                } else {
                    sStyle = uneditedStepStyle;
                }
            }
            return (
                <JourneyBarNextStep
                    name={step.name}
                    width={width}
                    style={{
                        ...sStyle,
                        fill: isHovering ? '#FAA800' : sStyle.fill
                    }}
                />
            );
        }
    };

    return (
        <div
            key={`step${index}`}
            id={`progressstep-${step.title.replace(/\s/g, '')}`}
            style={{
                ...stepStyle,
                height: 30,
                xwidth: 222,
                cursor: step.enabled ? 'pointer' : 'default'
            }}
            onClick={step.enabled ? () => onClick(index, step) : undefined}
        >
            <div
                style={
                    index === currentStep
                        ? currentStepLabelStyle
                        : onwardStepLabelStyle
                }
                onMouseOver={() => updateHovering(step, true)}
                onMouseOut={() => updateHovering(step, false)}
            >
                {step.title}
            </div>
            <div
                style={{
                    position: 'relative',
                    top: -20,
                    zIndex: 0
                }}
                onMouseOver={() => updateHovering(step, true)}
                onMouseOut={() => updateHovering(step, false)}
            >
                {StepType(index, step, isHovering)}
            </div>
        </div>
    );
};

export default JourneyBarStep;
